import Icon from '../components/Icon.vue'

Icon.register({"exchange-alt":{"width":512,"height":512,"paths":[{"d":"M0 168V152C0 138.7 10.7 128 24 128H384V80C384 58.6 409.9 48 425 63L505 143C514.3 152.4 514.3 167.6 505 177L425 257C410 272 384 261.5 384 240V192H24C10.7 192 0 181.3 0 168zM488 320H128V272C128 250.7 102.1 239.9 87 255L7 335C-2.3 344.4-2.3 359.6 7 369L87 449C102.1 464 128 453.4 128 432V384H488C501.3 384 512 373.3 512 360V344C512 330.7 501.3 320 488 320z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/exchange-alt.js
// module id = null
// module chunks = 